{
  "name": "cnx-base",
  "version": "1.8.24",
  "private": true,
  "description": "JAPP - monorepo",
  "author": "Toni Leppänen <toni@codenamex.io>",
  "packageManager": "pnpm@11.10.0+sha512.0b7f8b98060031904c017e3a41eb187a16d40eeb829b95c4f8cb03681761fc4ab53dd219115b9b447f4dce1a05a214764461e7d3703392a9f32f9511ce8c86c8",
  "engines": {
    "node": ">=22.14.0",
    "pnpm": ">=10.0.0"
  },
  "scripts": {
    "build": "pnpm -r --if-present run build",
    "dev": "pnpm -r --stream --if-present --parallel run dev",
    "dev-test": "pnpm -r --stream --if-present run dev-test",
    "start": "pnpm -r --if-present --parallel start",
    "test": "pnpm -r --if-present run test",
    "testdb:up": "docker compose -f docker-compose-testdb.yml up -d",
    "testdb:down": "docker compose -f docker-compose-testdb.yml down -v",
    "testdb:reset": "rm -fr volumes && docker system prune -af",
    "testdb:restart": "pnpm run testdb:down && pnpm run testdb:reset && pnpm run testdb:up",
    "format": "pnpm prettier --write \"apps/{ui,server,integrator}/src/**/*.{ts,tsx}\"",
    "cypress": "pnpm --filter ui run cypress",
    "swagger": "pnpm --filter server run swagger",
    "e2e:integrator": "pnpm --filter @cnx/integrator run e2e:integrator",
    "e2e:integrator:local": "pnpm run testdb:up && pnpm --filter @cnx/integrator run e2e:integrator:local",
    "ory": "ory tunnel http://localhost:4000 --dev --project dreamy-goldstine-qkbp7cm3l4"
  },
  "keywords": [],
  "license": "ISC",
  "devDependencies": {
    "prettier": "2.8.8"
  }
}
